import {usePlant} from './usePlant'

export const usePlantFullName: () => string = () => {
  const plant = usePlant()
  return plant?.fullName ?? ''
}
